import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { AdRequestParameterTemplate, AdRequestParameterTemplateSearchParam, AdRequestDefaultParameter } from "@app/core";
import { map } from 'rxjs/operators';
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AdRequestParameterTemplateService {

    private path = '/ad_request_parameter_templates';

    constructor(
        private http: AlloxApiService,
    ) { }

    /**
     * 検索
     * @remarks
     * 広告リクエストパラメータテンプレートを検索する。
     * 配信面(delivery_scopes)とフォーマット(ad_foramts)は下記のように展開する。
     * delivery_scopes=1&delivery_scopes=2&delivery_scopes=3
     *
     * @param ｛AdRequestParameterTemplateSearchParam｝ param - 広告リクエストパラメータテンプレートの検索用パラメータ
     * @returns 検索した広告リクエストパラメータテンプレート情報
     */
    public search(param: AdRequestParameterTemplateSearchParam) {
        const json = param.toJSON();
        const query =  Object.keys(json)
            .filter(k => json[k] != null)
            .reduce((prev, k) => {
                const value = json[k];
                if (Array.isArray(value)) {
                    // 配列の場合、各要素をクエリパラメータとして追加
                    const arrayParams = value.map(v => '&' + k + '=' + encodeURIComponent(v)).join('');
                    return prev += arrayParams;
                } else {
                    // 配列でない場合、通常のクエリパラメータとして追加
                    return prev += '&' + k + '=' + encodeURIComponent(json[k]);
                }
            }, '')
            .replace('&', '?');

        return this.http.get<[]>(this.path + query).pipe(
            map(objs => objs.map(obj => new AdRequestParameterTemplate(obj)))
        );
    }

    /**
     * 取得
     * @remarks
     * 広告リクエストパラメータテンプレートを取得する。
     * @param ｛number｝ id - 広告リクエストパラメータテンプレートID
     * @returns IDに紐付いた広告リクエストパラメータテンプレート情報
     */
    public fetch(id: number) {
        return this.http.get(this.path + '/' + id).pipe(
            map(obj => new AdRequestParameterTemplate(obj))
        );
    }

    /**
     * 登録
     * @remarks
     * 広告リクエストパラメータテンプレートを登録する。
     * @param ｛AdRequestParameterTemplate｝ item - 登録する広告リクエストパラメータテンプレート情報
     * @returns 実行結果
     */
    public post(item: AdRequestParameterTemplate) {
        const json = item.toCreateEditItemJson();
        return this.http.post(this.path, json);
    }

    /**
     * 更新
     * @remarks
     * 広告リクエストパラメータテンプレートを更新する。
     * @param ｛AdRequestParameterTemplate｝ item - 更新する広告リクエストパラメータテンプレート情報
     * @returns 実行結果
     */
    public put(item: AdRequestParameterTemplate) {
        const json = item.toCreateEditItemJson();
        return this.http.put(this.path + '/' + item.id, json);
    }

    /**
     * 削除
     * @remarks
     * 広告リクエストパラメータテンプレートを削除する。
     * @param ｛AdRequestParameterTemplate[]｝ items - 削除する広告リクエストパラメータテンプレート情報の配列
     * @returns 実行結果
     */
    public deletes(items: AdRequestParameterTemplate[]) {
        const dItems = items.map(item => item.toDeleteItemJSON());
        return this.http.post(this.path + '/delete', { delete_items: dItems });
    }

    /**
     * 初期パラメータの取得
     * @remarks
     * 広告リクエストパラメータテンプレートの初期パラメータを取得する。
     * @returns 広告リクエストパラメータテンプレートの初期パラメータ情報
     */
    public searchDefaultParams(): Observable<AdRequestDefaultParameter[]> {
        return this.http.get<AdRequestDefaultParameter[]>(this.path + '/default').pipe(
            map(obj => obj.map(item  => new AdRequestDefaultParameter(item)))
        );
    }

}
